import MicroModal from 'micromodal';
import './js/main.js';

jQuery.event.special.touchstart = {
    setup: function( _, ns, handle ) {
        this.addEventListener("touchstart", handle, { passive: !ns.includes("noPreventDefault") });
    }
};
jQuery.event.special.touchmove = {
    setup: function( _, ns, handle ) {
        this.addEventListener("touchmove", handle, { passive: !ns.includes("noPreventDefault") });
    }
};
jQuery.event.special.wheel = {
    setup: function( _, ns, handle ){
        this.addEventListener("wheel", handle, { passive: true });
    }
};
jQuery.event.special.mousewheel = {
    setup: function( _, ns, handle ){
        this.addEventListener("mousewheel", handle, { passive: true });
    }
};

import { library, dom } from '@fortawesome/fontawesome-svg-core';
import { faLinkedin, faFacebookSquare, faTwitterSquare } from '@fortawesome/free-brands-svg-icons';
import { faChevronRight, faChevronLeft, faChevronDown, faSearch, faTimes, faBars, faPlus, faMinus } from '@fortawesome/free-solid-svg-icons';

MicroModal.init();

library.add(
    faLinkedin, 
    faFacebookSquare, 
    faTwitterSquare,
    faChevronRight, 
    faChevronLeft, 
    faChevronDown, 
    faSearch, 
    faTimes, 
    faBars, 
    faPlus, 
    faMinus
);

dom.watch();